var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.875,
    height: 22.875,
    viewBox: "0 0 22.875 22.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#faad43;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.437,12A11.437,11.437,0,1,1,12,.563,11.437,11.437,0,0,1,23.437,12ZM12.307,4.344a5.974,5.974,0,0,0-5.375,2.94.554.554,0,0,0,.125.75l1.6,1.213a.553.553,0,0,0,.769-.1C10.25,8.105,10.815,7.5,12.069,7.5c.942,0,2.108.606,2.108,1.52,0,.691-.57,1.045-1.5,1.567-1.085.608-2.52,1.365-2.52,3.259v.184a.553.553,0,0,0,.553.553h2.583a.553.553,0,0,0,.553-.553v-.061c0-1.313,3.836-1.367,3.836-4.919C17.681,6.373,14.906,4.344,12.307,4.344ZM12,15.782A2.121,2.121,0,1,0,14.121,17.9,2.124,2.124,0,0,0,12,15.782Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoOrange);
export default __webpack_public_path__ + "static/media/icon_info_orange.caab88a00974c5dc7a7d76ffd398892c.svg";
export { ForwardRef as ReactComponent };